import { render, staticRenderFns } from "./SignatureTool.vue?vue&type=template&id=3a152406&"
import script from "./SignatureTool.vue?vue&type=script&lang=js&"
export * from "./SignatureTool.vue?vue&type=script&lang=js&"
import style0 from "./SignatureTool.vue?vue&type=style&index=0&id=3a152406&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports